// extracted by css-extract-rspack-plugin
export default {"root":"root-OmFbru text-body-md","link":"link-XzohDl"};